import styled from 'styled-components';

export const PromptWrapper = styled.div`
  padding: 6px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

// the height should remove the tab content height
// so that we will remove the outer scroll bar
export const ContentWrapper = styled.main`
  height: calc(100% - 25px);
  width: 100%;
  display: flex;
`;

export const LeftSection = styled.div`
  margin-top: 16px;
  overflow-y: scroll;

  h3 {
    font-size: 16px !important;
  }
`;

export const LeftSectionContent = styled.div`
  padding: 16px;
  border: 1px solid rgb(0 0 0 / 15%);
  border-radius: 8px;
  background: #fff;
`;

export const LeftSectionHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RightSection = styled.div`
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  align-items: center;
`;

export const RightSectionContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
